module.exports = __webpack_public_path__ + "static/img/api@2x.aee55c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/api@2x.png
// module id = /F5e
// module chunks = 2